const Home = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none">
    <path
      fill="#222"
      fillRule="evenodd"
      d="M24.49 16.423c-.282 0-.51.206-.51.46v8.197h-5.473v-5.145c0-.254-.228-.46-.51-.46h-3.994c-.282 0-.51.206-.51.46v4.08c0 .253.228.46.51.46.281 0 .51-.207.51-.46v-3.62h2.975v4.685H8.02V13.819L16 8.049l8.171 5.908c.22.159.54.127.717-.071a.43.43 0 0 0-.08-.647l-8.49-6.138a.554.554 0 0 0-.637 0l-8.49 6.138a.445.445 0 0 0-.191.359V25.54c0 .254.228.46.51.46h16.98c.282 0 .51-.206.51-.46v-8.657c0-.254-.228-.46-.51-.46Z"
      clipRule="evenodd"
    />
  </svg>
)
export { Home }
